import { adminAPI } from "../apis/AdminAPI.jsx";

class Logger {
  constructor() {
    this.sessionId = null;
    this.userId = null;
  }

  static getInstance() {
    if (!Logger.instance) {
      Logger.instance = new Logger();
    }
    return Logger.instance;
  }

  initialize(sessionId, userId) {
    this.sessionId = sessionId;
    this.userId = userId;
    console.log("Logger initialized:", { sessionId, userId });
  }

  //userId can come from Register or Corporate Register
  log(stepName, message, isError = false, errorStack = null, userId = null) {
    const logData = {
      sessionId: this.sessionId || "",
      userId: userId || this.userId || "",
      stepName,
      message,
      isError,
      errorStack,
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent,
    };

    // Send to your logging service/API
    this.sendToLoggingService(logData);
  }

  async sendToLoggingService(logData) {
    adminAPI
      .postLogs(logData)
      .then((response) => {
        if (response.status === 200) {
          console.log("sendToLoggingService success", response);
        }
      })
      .catch((error) => {
        //Failure
        console.error("sendToLoggingService failed:", error);
      });
  }

  // Clear session data on logout
  clearSession() {
    console.log("Logger session cleared");
    this.sessionId = null;
    this.userId = null;
  }
}

export default Logger.getInstance();
